import { css } from 'twin.macro';
import { FormLabel, InputGroup } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { fetchWrapper, getTeamIdFromURL, toastWrapper, getChannelIdFromSettingsURL } from '../../../../../_helpers';
import { connect } from 'react-redux';
import { ActionStyles } from '../../../../Admin/reusableStyles';

//assets
import { VscLoading } from 'react-icons/vsc';
import FormSvg from '../../../../../assets/forms.svg';
import SortedTableHeaderIcon from '../../../../Admin/SortedTableHeaderIcon';
import Pagination from '../../../../Admin/Pagination';
import ChannelSelectFilter from '../../../../Admin/ChannelSelectFilter';
import { FormPackageTable } from '../TeamSettingFormPackage';
import FormGroupAccordionModal from './FormGroupAccordionModal';
import dayjs from 'dayjs';

const SubmissionTable = ({ search, teamRooms, channel }) => {
    const [visitTemplates, setVisitTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const teamId = getTeamIdFromURL();
    const channelIdFromUrl = getChannelIdFromSettingsURL();
    const [fetchToggle, setFetchToggle] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalResults, setTotalResults] = useState(10);
    const [rooms, setRooms] = useState([]);
    const [sortBy, setSortBy] = useState({
        key: 'createdAt',
        direction: 'desc',
    });

    useEffect(() => {
        if (teamId && teamRooms[teamId]) {
            setRooms(teamRooms[teamId]?.rooms);
        }
    }, [teamRooms, teamId]);

    useEffect(() => {
        const getData = async () => {
            try {
                setLoading(true);
                const res = await fetchWrapper.get(
                    `userFormGroupData?page=${currentPage}&limit=10${channel || channelIdFromUrl ? `&chatroom=${channel?.value || channel?._id || channelIdFromUrl}` : ''}&team=${teamId}`
                );
                setVisitTemplates(res.results);
                setTotalResults(res.totalResults);
            } catch (error) {
                console.log('ERROR => ', error);
                toastWrapper.error(error?.message);
            } finally {
                setLoading(false);
            }
        };
        getData();
    }, [teamId, sortBy, search, currentPage, channel, fetchToggle]);

    const handleSort = (fieldName) => {
        setSortBy({ direction: sortBy.direction === 'asc' ? 'desc' : 'asc', key: fieldName });
    };

    return (
        <div>
            {loading ? (
                <h4 className="text-center">
                    <VscLoading className="spin" fontSize="42" />
                </h4>
            ) : visitTemplates?.length > 0 ? (
                <div className="custom-card">
                    <FormPackageTable className="w-100">
                        <thead>
                            <tr>
                                <th
                                    onClick={() => handleSort('createdAt')}
                                    css={css`
                                        color: inherit;
                                        cursor: pointer;
                                    `}
                                >
                                    S.N
                                    <SortedTableHeaderIcon sortConfig={sortBy} fieldName={'createdAt'} />
                                </th>
                                <th>Form Group Submissions</th>
                                <th>Channel</th>
                                <th>Status</th>
                                <th>Submitted At</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visitTemplates?.map((templateData, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{10 * (currentPage - 1) + index + 1}</td>
                                        <td
                                            className="d-flex align-items-center"
                                            css={css`
                                                flex: 1;
                                            `}
                                        >
                                            <div
                                                css={css`
                                                    display: flex;
                                                    flex-direction: column;
                                                    gap: 0.5rem;
                                                `}
                                            >
                                                <div
                                                    css={css`
                                                        display: flex;
                                                        flex-direction: row;
                                                    `}
                                                >
                                                    <span
                                                        css={css`
                                                            white-space: nowrap;
                                                            overflow: hidden;
                                                            text-overflow: ellipsis;
                                                            max-width: 50rem;
                                                        `}
                                                    >
                                                        {(templateData?.formGroupData || {})?.name}
                                                    </span>
                                                    {templateData?.archived ? (
                                                        <span className="badge badge-danger mx-2">Archived</span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <span
                                                className={`badge badge-sm ${templateData?.status === 'completed' ? 'badge-success' : 'badge-warning'}`}
                                            >
                                                {templateData?.status}
                                            </span>
                                        </td>
                                        <td>
                                            {rooms?.find((room) => room?._id === templateData?.chatroom)?.title || '-'}
                                        </td>
                                        <td>
                                            <td>{dayjs(templateData?.updatedAt).format('MMMM D, YYYY h:mm A')}</td>
                                        </td>
                                        <td>
                                            <ActionStyles className="mt-2">
                                                <FormGroupAccordionModal
                                                    mode={'view'}
                                                    data={templateData}
                                                    preview={true}
                                                />
                                            </ActionStyles>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </FormPackageTable>
                </div>
            ) : (
                <div
                    css={css`
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                    `}
                >
                    <img
                        src={FormSvg}
                        alt={'no data found'}
                        css={css`
                            width: 350px;
                            margin: 1rem 0;
                        `}
                    />
                    <h2 className="text-center">No Data</h2>
                </div>
            )}
            <div className="p-4">
                <Pagination
                    totalRecords={totalResults}
                    key={totalResults}
                    pageLimit={10}
                    pageNeighbours={1}
                    onPageChanged={(data) => {
                        setCurrentPage(Math.max(1, data.currentPage));
                    }}
                />
            </div>
        </div>
    );
};
const mapStateToProps = (state) => ({
    teamRooms: state.rooms.teamRooms,
});

export default connect(mapStateToProps, {})(SubmissionTable);
